<div id="boost-your-knowledge-overlay" class="bottom-right-overlay bgc-glass" [ngStyle]="overlayStyles">
  <p class="larger-font">
    Register for upcoming onboarding webinars to
    <ng-container *ngTemplateOutlet="boostYourKnowledgeLink"></ng-container>.
  </p>
</div>
<ng-template #boostYourKnowledgeLink>
  <a
    class="overlay-link"
    (click)="onLinkClick()"
    href="https://orchestrators.genesys.com/resources/onboarding?product=genesys-cloud-cx#onboarding-webinars"
    target="_blank"
    title="Boost Your Knowledge Genesys Orchestrators link"
    >Boost Your Knowledge</a
  >
</ng-template>
